// Deliberately illustrative energy units (% capacity per second), not plant sizing.
export const initialSimulation = () => ({ time: 0, energy: 55, input: 1.5, output: 0, temperature: 103.75 });

export function advanceSimulation(state, seconds, solar, demand, running) {
  const dt = Math.min(Math.max(seconds, 0), 0.1);
  const input = Math.max(0, Math.min(solar, 100)) / 100 * 2;
  const requested = demand ? 2.6 : 0;
  const output = Math.min(requested, input + state.energy / Math.max(dt, 0.001));
  state.input = input;
  state.output = output;
  state.temperature = 25 + solar / 100 * 105;
  if (running) {
    state.time += dt;
    state.energy = Math.max(0, Math.min(100, state.energy + (input - output) * dt));
  }
  return state;
}

export function storageStatus(state, running) {
  if (!running) return "paused";
  if (state.energy <= 0.05 && state.output >= state.input) return "empty";
  if (state.energy >= 99.95 && state.input >= state.output) return "full";
  if (state.input > state.output) return "charging";
  if (state.input < state.output) return "discharging";
  return "stable";
}